// services/functions/mintLicenseSeatCode.ts — typed wrapper for the
// LSEAT-code mint callable. Direct mint of a seat code for a
// license org (distinct from the LINV invite-link flow): the
// resulting LSEAT- code is copied / pasted into the mobile app's
// "Have an unlock code?" tile, the member redeems, an
// org_seat_allocations doc is created.
//
// Plaintext is returned ONCE; the page renders it inside a
// one-shot reveal modal.

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  licenseOrgId: string;
  productId: string;
  maxUses: number;
  /** ISO 8601 timestamp; null = no expiry. */
  expiresAtIso: string | null;
  note: string | null;
}

interface Output {
  code: string;
  licenseOrgId: string;
  productId: string;
  maxUses: number;
  /** ISO 8601 timestamp; absent = no expiry. */
  expiresAt?: string;
}

const callable = httpsCallable<Input, Output>(
  functions,
  'mintLicenseSeatCode',
);

export async function mintLicenseSeatCode(input: Input): Promise<Output> {
  const res = await callable(input);
  return res.data;
}
